import moment from "moment";
import { useEffect, useState } from "react";
import { Button, openModal } from "risa-oasis-ui_v2";
import { DetailsCard } from "../../../components/detailsCard/detailsCard";
import HealthCareInvitationModal from "../../../components/modals/healthCareInvitationModal/healthCareInvitationModal";
import NewClientModal from "../../../components/modals/newClientModal/newClientModal";
import { ClientConfigModel } from "../../../data-model/clientConfig";
import { getStateName } from "../../../enums/usStates";

const ClientCardDetails = (props: {
  singleHealthCareData: ClientConfigModel;
}) => {
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openInvitationModal, setOpenInvitationModal] =
    useState<boolean>(false);
  const stateName = () => {
    if (props?.singleHealthCareData?.Address?.State) {
      const stateNameRetreived = getStateName(
        props?.singleHealthCareData?.Address?.State,
      );
      return stateNameRetreived ? stateNameRetreived : "-";
    } else {
      return "-";
    }
  };

  const generateCommunicationDetails = () => {
    if (!props?.singleHealthCareData) return [];
    return [
      {
        header: "Street Address",
        text: props?.singleHealthCareData?.Address?.StreetAddress || "-",
      },
      {
        header: "Client Name",
        text: props?.singleHealthCareData?.name || "-",
      },
      {
        header: "City",
        text: props?.singleHealthCareData?.Address?.City || "-",
      },
      {
        header: "State",
        text: stateName(),
      },
      {
        header: "Zip Code",
        text: props?.singleHealthCareData?.Address?.ZIP || "-",
      },
      {
        header: "Country",
        text: props?.singleHealthCareData?.Address?.Country || "USA",
      },
      {
        header: "Phone Number",
        text: props?.singleHealthCareData?.PhoneNumber || "-",
      },
      {
        header: "RISA Phone Number",
        text: props?.singleHealthCareData?.RisaPhoneNumber || "-",
      },
      {
        header: "RISA Fax Number",
        text: props?.singleHealthCareData?.RisaFaxNumber || "-",
      },
    ];
  };
  useEffect(() => {
    if (openEditModal) {
      openModal("new-client-modal");
    }
  }, [openEditModal]);

  useEffect(() => {
    if (openInvitationModal) {
      openModal("invitation-modal");
    }
  }, [openInvitationModal]);

  return (
    <>
      <div className="hc-detail__container">
        <div className="hc-detail__header">
          {props?.singleHealthCareData?.Name || ""}
        </div>
        <div className="hc-detail__content">
          <div className="hc-detail__primary">
            <div className="hc-detail__primary--text">Primary Details</div>
            <DetailsCard
              details={[
                {
                  header: "NPI",
                  text: props?.singleHealthCareData?.NPI || "-",
                },
                {
                  header: "Tax Id",
                  text: props?.singleHealthCareData?.TaxID || "-",
                },
                {
                  header: "FHIR ID",
                  text: props?.singleHealthCareData?.FhirId || "-",
                },
                {
                  header: "FHIR Client ID",
                  text: props?.singleHealthCareData?.fhir_client || "-",
                },
                {
                  header: "Created At",
                  text:
                    moment(props?.singleHealthCareData?.created_at).format(
                      "DD MMM YYYY HH:mm",
                    ) || "-",
                },
                {
                  header: "Updated At",
                  text:
                    moment(props?.singleHealthCareData?.updated_at).format(
                      "DD MMM YYYY HH:mm",
                    ) || "-",
                },
                {
                  header: "Updated By",
                  text: props?.singleHealthCareData?.updated_by || "-",
                },
              ]}
              elementsInOneRow={2}
              showBorder={true}
            />
          </div>
          <div className="hc-detail__communication">
            <div className="hc-detail__communication--text">
              Communication Details
            </div>
            <DetailsCard
              details={generateCommunicationDetails()}
              elementsInOneRow={2}
              showBorder={true}
            />
          </div>
          <div className="hc-detail__cta">
            <Button
              disabled={false}
              children={"Send Invite"}
              onClick={() => {
                setOpenInvitationModal(true);
              }}
              buttonType={"primary"}
              size={"medium"}
            />
            <Button
              disabled={false}
              children={"Edit Details"}
              onClick={() => {
                setOpenEditModal(true);
              }}
              buttonType={"secondary"}
              size={"medium"}
            />
          </div>
        </div>
      </div>
      {openEditModal && (
        <NewClientModal
          data={props?.singleHealthCareData}
          onModalClose={(status) => setOpenEditModal(status)}
          type={"edit"}
        />
      )}
      {openInvitationModal && (
        <HealthCareInvitationModal
          facilityId={props?.singleHealthCareData?.DocId || ""}
          onModalClose={(status) => setOpenInvitationModal(status)}
        />
      )}
    </>
  );
};

export default ClientCardDetails;
